import { render, staticRenderFns } from "./NewPasswordRequest.vue?vue&type=template&id=7f0bf645&scoped=true&"
import script from "./NewPasswordRequest.vue?vue&type=script&lang=js&"
export * from "./NewPasswordRequest.vue?vue&type=script&lang=js&"
import style0 from "./NewPasswordRequest.vue?vue&type=style&index=0&id=7f0bf645&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0bf645",
  null
  
)

export default component.exports